import { CreateAccountInterface } from "../interface/CreateAccountInterface";

export const CreateAccountInit: CreateAccountInterface = {
    coEmail: "",
    companyId: "",
    companyName: "",
    contactNo : "",
    deleteFlag: "",
    codeDutyGroupTypeId : 0,
    departmentId: "",
    departmentName: "",
    dutyGroupId: 0,
    dutyGroupName:"",
    dutyGroupTypeName:"",
    extensionNo:"",
    loginId: "",
    modAt: "",
    orgName: "",
    password: "",
    phoneNo: "",
    positionId: 0,
    regAt: "",
    remark: "",
    roleName: "",
    teamId: "",
    teamName: "",
    title: "",
    userId: 0,
    userName: ""
};